import Fondo from "./img/Fondo.jpg"
import GluonKnowledgeLogo from "./img/Gluon_Logo.jpg";
import GKMLogo from "./img/gkm_logo.png";
import NoImage from "./img/noimage.png";

export default {
    Fondo: Fondo,
    GKMLogo: GKMLogo,
    GluonKnowledgeLogo: GluonKnowledgeLogo,
    NoImage: NoImage
};
